import React from "react"
import { ShadowRoot } from "./ShadowRoot"
import Cart from "../utils/Cart"

const BadgeBlock = ({ product }) => {
    const badgeData = Cart.getProductBadgeData(product)
    return (
        <>
            {
                badgeData.length > 0 && <div className='product-image-badge-container'>
                {
                    badgeData.map((o) => {
                    return <ShadowRoot><div dangerouslySetInnerHTML={{ __html: o.value }} ></div></ShadowRoot>
                    })
                }
                </div>
            }
        </>
    )
}

export default BadgeBlock;